import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "benefit-row" }
const _hoisted_2 = { class: "my-table-row" }
const _hoisted_3 = { class: "the-col" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Benefit", -1)
const _hoisted_5 = { class: "the-value" }
const _hoisted_6 = {
  key: 0,
  class: "the-col flex-4"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, " ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "the-value the-number confirmation-waived text-danger" }, " Benefit is Waived ", -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "the-col"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Tier", -1)
const _hoisted_12 = { class: "the-value" }
const _hoisted_13 = {
  key: 2,
  class: "the-col"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Amount Due Today", -1)
const _hoisted_15 = { class: "the-value the-number" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 3,
  class: "the-col"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Monthly Premium", -1)
const _hoisted_19 = { class: "the-value the-number" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "the-label" }, "Effective Date Of Coverage", -1)
const _hoisted_22 = { class: "the-value the-number" }
const _hoisted_23 = {
  key: 0,
  class: "coverage-title"
}
const _hoisted_24 = { class: "my-table-row dep-rows" }
const _hoisted_25 = { class: "dep-name" }
const _hoisted_26 = { class: "dep-relation" }
const _hoisted_27 = {
  key: 1,
  class: "subsidy-note"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.benefit.planDescription), 1)
      ]),
      (_ctx.benefit.isWaived === true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
        : _createCommentVNode("", true),
      (
          _ctx.benefit.isWaived === false &&
          _ctx.benefit.benefitRateTypeId === _ctx.common.benefit.tier
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.tierName(_ctx.benefit)), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.benefit.isWaived === false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createTextVNode(" $" + _toDisplayString(_ctx.helper.formatNumber(_ctx.benefit.initialAmount!)) + " ", 1),
              (_ctx.doesBenefitHaveSubsidy())
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, "*"))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.benefit.isWaived === false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createTextVNode(" $" + _toDisplayString(_ctx.monthlyPrice(_ctx.benefit)) + "/Month ", 1),
              (_ctx.doesBenefitHaveSubsidy())
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, "*"))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.benefit.isWaived === false)
        ? (_openBlock(), _createElementBlock("div", {
            key: 4,
            class: _normalizeClass(["the-col", {
          'flex-2': _ctx.benefit.benefitRateTypeId !== _ctx.common.benefit.tier,
        }])
          }, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.formatEffectiveDate(_ctx.benefit.benefitEndDate!)), 1)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    (
        _ctx.benefit.electionDependentBenefits &&
        _ctx.benefit.electionDependentBenefits.length > 0
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, " Coverage "))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_24, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.benefit.electionDependentBenefits, (dependentId) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "the-col",
          key: dependentId
        }, [
          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.coverageDependentName(dependentId)), 1),
          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.coverageDependentRelation(dependentId)), 1)
        ]))
      }), 128))
    ]),
    (_ctx.doesBenefitHaveSubsidy() && !_ctx.benefit.isWaived)
      ? (_openBlock(), _createElementBlock("small", _hoisted_27, _toDisplayString(_ctx.getSubsidyMessage()), 1))
      : _createCommentVNode("", true)
  ]))
}